var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('sui-message',{attrs:{"positive":"","header":"You completed and viewed all forms.","size":"small","dismissable":""},on:{"dismiss":_vm.handleDismiss}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }